module.exports = __webpack_public_path__ + "static/media/stamp.6487abb9.svg";